import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, Transition as _Transition, vModelText as _vModelText, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-612e51a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader-overlay flex justify-center items-center"
}
const _hoisted_2 = { class: "items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 2,
  class: "flex flex-col items-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-white my-2",
  for: "progress-bar"
}, "0%", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("progress", {
  id: "progress-bar",
  value: "0",
  max: "100"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "text-white mt-3 text-center" }
const _hoisted_10 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_11 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_12 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" This may take a few seconds to a few minutes depending on your internet connection. ")
const _hoisted_14 = { class: "m-3" }
const _hoisted_15 = {
  key: 0,
  class: "bg-red-500 rounded-t-md"
}
const _hoisted_16 = { class: "text-center p-3" }
const _hoisted_17 = { class: "text-center text-white text-sm" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Game is Rejected. ")
const _hoisted_19 = { class: "text-center p-3" }
const _hoisted_20 = { class: "text-center text-white text-sm" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Update cover photo.  ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Add Photo ")
const _hoisted_23 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_24 = {
  key: 1,
  class: "my-3 text-gray-300 text-sm"
}
const _hoisted_25 = { class: "text-center p-3" }
const _hoisted_26 = { class: "text-center text-white text-sm" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Update game profile image.  ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Add Photo ")
const _hoisted_29 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_30 = {
  key: 1,
  class: "my-3 text-gray-300 text-sm"
}
const _hoisted_31 = { class: "sm:flex text-white items-end sm:justify-between absolute bottom-0 w-full" }
const _hoisted_32 = { class: "flex-grow flex items-end" }
const _hoisted_33 = { class: "relative inline-block m-0 ml-4 mb-3" }
const _hoisted_34 = { class: "ml-40 inline-block mb-3" }
const _hoisted_35 = { class: "text-md sm:text-2xl text-white font-semibold drop-shadow-md truncate" }
const _hoisted_36 = { class: "text-xs sm:text-md text-gray-200 my-2" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Invite Gamers ")
const _hoisted_38 = { class: "m-3" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Change Header Image ")
const _hoisted_40 = { class: "lg:grid lg:grid-cols-8 mt-3" }
const _hoisted_41 = { class: "lg:col-span-6 lg:mr-1.5 border-t border-black-border flex flex-col" }
const _hoisted_42 = { class: "flex flex-row items-center text-sm border-b border-black-border mainTab mt-2" }
const _hoisted_43 = { role: "presentation" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Game Page ")
const _hoisted_45 = { role: "presentation" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xr-icon-token mr-2" }, null, -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Game Tokens")
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { role: "presentation" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Releases ")
const _hoisted_51 = {
  id: "pills-tabContent",
  class: "flex-grow"
}
const _hoisted_52 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_53 = { class: "nav nav-sub-tabs" }
const _hoisted_54 = {
  id: "nav-tabContent",
  class: "h-full"
}
const _hoisted_55 = {
  key: 0,
  class: "p-3 bg-black-body"
}
const _hoisted_56 = {
  class: "text-white p-4 pb-0",
  id: "nav-details"
}
const _hoisted_57 = {
  key: 1,
  class: "p-3 bg-black-body"
}
const _hoisted_58 = {
  class: "text-white p-4 pb-0",
  id: "nav-about"
}
const _hoisted_59 = {
  key: 2,
  class: "bg-black-body h-full"
}
const _hoisted_60 = {
  class: "text-white pb-0 h-full",
  id: "nav-gallery"
}
const _hoisted_61 = {
  key: 1,
  class: "bg-black-body h-full"
}
const _hoisted_62 = { key: 2 }
const _hoisted_63 = { class: "p-3 lg:col-span-2 lg:ml-1.5 bg-black-body text-sm mt-3 lg:mt-0" }
const _hoisted_64 = { class: "section-editing-environment" }
const _hoisted_65 = { class: "flex justify-start p-3" }
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-edit-net relative top-1\" data-v-612e51a4><span class=\"path1\" data-v-612e51a4></span><span class=\"path2\" data-v-612e51a4></span><span class=\"path3\" data-v-612e51a4></span><span class=\"path4\" data-v-612e51a4></span></span>", 1)
const _hoisted_67 = { class: "px-3" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-300 font-bold" }, "Editing Environment", -1))
const _hoisted_69 = { class: "text-gray-text py-4" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode("You created this game")
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Preview Page ")
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/_createTextVNode("Play Game")
const _hoisted_75 = {
  key: 1,
  class: "text-gray-text my-4"
}
const _hoisted_76 = ["href"]
const _hoisted_77 = { class: "my-4" }
const _hoisted_78 = {
  key: 0,
  class: "py-3"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text" }, "Select version to be reviewed", -1))
const _hoisted_80 = {
  key: 0,
  class: "py-1.5"
}
const _hoisted_81 = { class: "text-gray-text mb-1" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select Web GL release", -1))
const _hoisted_83 = ["value"]
const _hoisted_84 = {
  key: 1,
  class: "py-1.5"
}
const _hoisted_85 = { class: "text-gray-text mb-1" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: ""
}, "Select Android release", -1))
const _hoisted_87 = ["value"]
const _hoisted_88 = ["disabled"]
const _hoisted_89 = ["disabled"]
const _hoisted_90 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-release-test-net\" data-v-612e51a4><span class=\"path1\" data-v-612e51a4></span><span class=\"path2\" data-v-612e51a4></span><span class=\"path3\" data-v-612e51a4></span><span class=\"path4\" data-v-612e51a4></span><span class=\"path5\" data-v-612e51a4></span><span class=\"path6\" data-v-612e51a4></span><span class=\"path7\" data-v-612e51a4></span><span class=\"path8\" data-v-612e51a4></span><span class=\"path9\" data-v-612e51a4></span></span>", 1)
const _hoisted_91 = /*#__PURE__*/_createTextVNode("   Checklist ")
const _hoisted_92 = {
  key: 0,
  class: "bg-black-header rounded-lg absolute top-6 w-48 z-20 text-sm p-4"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs mb-2 text-white" }, "Items to be updated before submitting", -1))
const _hoisted_94 = { class: "flex mb-1" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "Game Detail", -1))
const _hoisted_96 = { class: "flex mb-1" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "About", -1))
const _hoisted_98 = { class: "flex mb-1" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "Header Image", -1))
const _hoisted_100 = { class: "flex mb-1" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "Profile Image", -1))
const _hoisted_102 = { class: "flex" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "Gallery", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-t border-black-border border-solid" }, null, -1))
const _hoisted_105 = { class: "section-testnet-environment" }
const _hoisted_106 = { class: "flex justify-start p-3" }
const _hoisted_107 = /*#__PURE__*/_createStaticVNode("<span class=\"xr-test-net relative top-1\" data-v-612e51a4><span class=\"path1\" data-v-612e51a4></span><span class=\"path2\" data-v-612e51a4></span><span class=\"path3\" data-v-612e51a4></span><span class=\"path4\" data-v-612e51a4></span></span>", 1)
const _hoisted_108 = { class: "px-3" }
const _hoisted_109 = { class: "text-gray-300 font-bold" }
const _hoisted_110 = {
  key: 0,
  class: "text-blue-primary font-bold pt-1"
}
const _hoisted_111 = {
  key: 1,
  class: "text-blue-primary font-bold pt-1"
}
const _hoisted_112 = {
  key: 2,
  class: "text-yellow-bar font-bold pt-1"
}
const _hoisted_113 = {
  key: 3,
  class: "text-yellow-bar font-bold pt-1"
}
const _hoisted_114 = { class: "text-gray-text pt-4" }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("Last pushed changes")
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_117 = { key: 4 }
const _hoisted_118 = { key: 0 }
const _hoisted_119 = /*#__PURE__*/_createTextVNode("Play Game")
const _hoisted_120 = {
  key: 1,
  class: "text-gray-text my-4"
}
const _hoisted_121 = ["href"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon float-start me-4 d-flex" }, null, -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-t border-black-border border-solid" }, null, -1))
const _hoisted_124 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_125 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_126 = { class: "flex items-center justify-center min-h-full p-1 text-center sm:p-0" }
const _hoisted_127 = { class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-2xl w-full m-2" }
const _hoisted_128 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_129 = { class: "modal-content bg-black-body text-white" }
const _hoisted_130 = { class: "modal-body p-10 text-justify z-50 relative" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-300 text-md mb-5 text-center font-bold" }, "Invite Gamers", -1))
const _hoisted_132 = {
  class: "my-6 border-b-2 border-black-header",
  if: "status == 4"
}
const _hoisted_133 = {
  class: "nav nav-tabs",
  id: "nav-tab"
}
const _hoisted_134 = { class: "flex items-center" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xr-test-net mr-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path4" })
], -1))
const _hoisted_136 = { class: "flex items-center" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "xr-main-net mr-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "path1" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path3" }),
  /*#__PURE__*/_createElementVNode("span", { class: "path4" })
], -1))
const _hoisted_138 = {
  key: 0,
  class: "border-0 pb-1"
}
const _hoisted_139 = { class: "text-gray-text text-sm" }
const _hoisted_140 = { class: "form-group mb-2" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-white my-3" }, " Already Invited Gamers ", -1))
const _hoisted_142 = {
  key: 0,
  class: "rounded-md bg-green-800 text-sm text-gray-200 px-2 py-1 inline-block mb-2 mr-2"
}
const _hoisted_143 = { class: "my-5" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm my-2 text-white" }, "Invite Gamers (Separate emails by comma(,) or spacing)", -1))
const _hoisted_145 = { class: "flex" }
const _hoisted_146 = /*#__PURE__*/_createTextVNode(" Add")
const _hoisted_147 = { class: "my-5" }
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-white" }, "Newly Invited Gamers", -1))
const _hoisted_149 = {
  class: "text-gray-text bg-black-primary p-2",
  style: {"min-height":"40px"}
}
const _hoisted_150 = {
  key: 1,
  class: "border-0 pb-1"
}
const _hoisted_151 = { class: "text-gray-text text-sm" }
const _hoisted_152 = { class: "form-group mb-2" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-white my-3" }, " Already Invited Gamers ", -1))
const _hoisted_154 = {
  key: 0,
  class: "rounded-md bg-green-800 text-sm text-gray-200 px-2 py-1 inline-block mb-2 mr-2"
}
const _hoisted_155 = { class: "my-5" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm my-2 text-white" }, "Invite Gamers (Separate emails by comma(,) or spacing)", -1))
const _hoisted_157 = { class: "flex" }
const _hoisted_158 = /*#__PURE__*/_createTextVNode(" Add")
const _hoisted_159 = { class: "my-5" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-white" }, "Newly Invited Gamers", -1))
const _hoisted_161 = {
  class: "text-gray-text bg-black-primary p-2",
  style: {"min-height":"40px"}
}
const _hoisted_162 = { class: "flex justify-between items-center" }
const _hoisted_163 = ["disabled"]
const _hoisted_164 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_165 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_166 = { class: "flex items-center justify-center min-h-full p-1 text-center sm:p-0" }
const _hoisted_167 = { class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-md w-full m-2" }
const _hoisted_168 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_169 = { class: "modal-content bg-black-body text-white" }
const _hoisted_170 = { class: "modal-body p-10 text-justify z-50 relative" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-300 text-md mb-5 text-center font-bold" }, "Update Game Title", -1))
const _hoisted_172 = { class: "border-0 pb-1" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white mb-2" }, "Game Title", -1))
const _hoisted_174 = { class: "flex justify-between items-center" }
const _hoisted_175 = /*#__PURE__*/_createTextVNode("  Update")
const _hoisted_176 = {
  key: 0,
  class: "fixed inset-0 bg-black-primary bg-opacity-50 transition-opacity"
}
const _hoisted_177 = {
  key: 0,
  class: "fixed z-50 inset-0 overflow-y-auto"
}
const _hoisted_178 = { class: "flex items-center justify-center min-h-full p-1 text-center sm:p-0" }
const _hoisted_179 = { class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:max-w-xl w-full m-2" }
const _hoisted_180 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_181 = { class: "modal-content bg-black-body text-white" }
const _hoisted_182 = { class: "modal-body p-10 text-justify z-50 relative" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-300 text-md mb-5 text-center font-bold" }, "Game Rejected", -1))
const _hoisted_184 = { class: "border-0 pb-1 text-center" }
const _hoisted_185 = { class: "rejectGame-table table-auto text-gray-text border border-black-border w-full" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-black-border border" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold" }, "Version(s)"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold" }, "Eligibility Issues")
  ])
], -1))
const _hoisted_187 = { class: "border-black-border border" }
const _hoisted_188 = { style: {"vertical-align":"top"} }
const _hoisted_189 = { class: "pb-4" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-sm text-white" }, "Resubmit for approval after necessary updates for above issue(s) are made", -1))
const _hoisted_191 = { class: "form-group py-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_game_details = _resolveComponent("game-details")!
  const _component_about = _resolveComponent("about")!
  const _component_gallery = _resolveComponent("gallery")!
  const _component_gameToken = _resolveComponent("gameToken")!
  const _component_gameRelease = _resolveComponent("gameRelease")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_gamesUpdateSubmitMainnetGameComponent = _resolveComponent("gamesUpdateSubmitMainnetGameComponent")!

  return (_openBlock(), _createElementBlock("main", null, [
    (_ctx.showLoader || _ctx.gameLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.showProgress)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/images/xr_loader.gif'),
                  style: {"width":"120px","height":"120px"},
                  class: "inline-block"
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            (_ctx.showProgress)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/images/xarcade-icon.png'),
                  style: {"width":"120px","height":"120px"},
                  class: "inline-block"
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.showProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.releaseTestNet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Your new game is being added."))
                : _createCommentVNode("", true),
              (_ctx.submitTestNet)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Your game is being reviewed."))
                : _createCommentVNode("", true),
              (_ctx.gameLoaded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Your game details are loading."))
                : _createCommentVNode("", true),
              _hoisted_13
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.status === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("a", {
                  class: "text-gray-200 hover:text-white hover:underline",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isDisplayRejectModal = true), ["prevent"]))
                }, "Here's Why")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isDisplayUploadCoverPhotoLabel)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["bg-yellow-700", { 'rounded-t-md':(_ctx.status != 1) }])
          }, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.coverFileInput.click())),
                  class: "border border-yellow-900 p-1 px-2 bg-yellow-900 hover:bg-yellow-800 transition-all duration-200 rounded-md"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-camera",
                    class: "text-white inline-block mr-2"
                  }),
                  _hoisted_22
                ]),
                _createElementVNode("input", {
                  style: {"display":"none"},
                  ref: "coverFileInput",
                  type: "file",
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pickCoverFile && _ctx.pickCoverFile(...args))),
                  accept: ".png, .jpg, .jpeg"
                }, null, 544),
                (_ctx.isDisplaySaveCoverPhotoOptions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateCoverImage && _ctx.updateCoverImage(...args))),
                        class: "mr-3 border border-success-check bg-success-check text-white p-1 px-2 hover:bg-green-700 duration-200 transition-all rounded-md"
                      }, "Confirm"),
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.revertCoverImage && _ctx.revertCoverImage(...args))),
                        class: "hover:underline"
                      }, "Cancel")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDisplaySaveCoverUploading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Uploading cover photo ..."))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.isDisplayUploadProfilePhotoLabel)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["bg-blue-primary", { 'rounded-t-md':(_ctx.status != 1 && !_ctx.isDisplayUploadCoverPhotoLabel) }])
          }, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$refs.fileInput.click())),
                  class: "border border-blue-900 p-1 px-2 bg-blue-900 hover:bg-blue-800 transition-all duration-200 rounded-md"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-camera",
                    class: "text-white inline-block mr-2"
                  }),
                  _hoisted_28
                ]),
                _createElementVNode("input", {
                  style: {"display":"none"},
                  ref: "fileInput",
                  type: "file",
                  onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                  accept: ".png, .jpg, .jpeg"
                }, null, 544),
                (_ctx.isDisplaySaveProfilePhotoOptions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("button", {
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.updateProfilePhoto && _ctx.updateProfilePhoto(...args))),
                        class: "mr-3 border border-success-check bg-success-check text-white p-1 px-2 hover:bg-green-700 duration-200 transition-all rounded-md"
                      }, "Confirm"),
                      _createElementVNode("button", {
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.revertProfilePhoto && _ctx.revertProfilePhoto(...args))),
                        class: "hover:underline"
                      }, "Cancel")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDisplaySaveProfileUploading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Uploading profile photo ..."))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["h-60 relative", _ctx.previewCoverImage?' bg-no-repeat bg-cover bg-center bg-blend-overlay bg-black-ori bg-opacity-40':' bg-black-ori']),
        style: _normalizeStyle([_ctx.previewCoverImage? { 'background-image': `url(${_ctx.previewCoverImage})`} : { 'background-image': '' }])
      }, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", {
                class: "border-black-border border border-dotted rounded-3xl w-36 bottom-0 h-36 absolute left-0 bg-cover bg-center bg-black-body",
                style: _normalizeStyle({ 'background-image': `url(${_ctx.previewImage})` })
              }, null, 4),
              _createElementVNode("button", {
                class: "absolute bg-black-body p-2 rounded-lg",
                style: {"bottom":"0px","left":"0"},
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isDisplayUploadProfilePhotoLabel = !_ctx.isDisplayUploadProfilePhotoLabel))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-camera",
                  class: "text-gray-text text-xl"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.gameName), 1),
              _createElementVNode("h6", _hoisted_36, _toDisplayString(_ctx.gameContent ? _ctx.gameContent : "Content Rating") + " | " + _toDisplayString(_ctx.gameCategory ? _ctx.gameCategory : "Category"), 1),
              _createElementVNode("button", {
                class: "bg-black-body text-white text-md p-2 px-3 rounded-md mr-1 h-10 w-10",
                type: "button",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isDisplayUpdateGameModal = true))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-cog" })
              ]),
              (_ctx.status === 2 || _ctx.status === 3)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "text-xs sm:text-sm md:text-md bg-black-body text-white p-2 px-3 rounded-md h-10",
                    type: "button",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.getInvitedGamers && _ctx.getInvitedGamers(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-user-plus",
                      class: "inline-block mr-1"
                    }),
                    _hoisted_37
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isDisplayUploadCoverPhotoLabel = !_ctx.isDisplayUploadCoverPhotoLabel)),
              class: "text-xs sm:text-sm md:text-md px-3 py-2 rounded-md bg-black-header text-gray-text hover:text-gray-300 transition-all duration-200"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-camera",
                class: "inline-block mr-2"
              }),
              _hoisted_39
            ])
          ])
        ])
      ], 6),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("ul", _hoisted_42, [
            _createElementVNode("li", _hoisted_43, [
              _createElementVNode("button", {
                class: _normalizeClass(["text-gray-text p-3 hover:text-white", _ctx.mainTabSelected=='games'?'active':'inActive']),
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.mainTabSelected = 'games')),
                "data-bs-target": "#pills-game-page"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-file-alt",
                  class: "inline-block mr-2"
                }),
                _hoisted_44
              ], 2)
            ]),
            _createElementVNode("li", _hoisted_45, [
              _createElementVNode("button", {
                class: _normalizeClass(["text-gray-text p-3 hover:text-white", _ctx.mainTabSelected=='tokens'?'active':'inActive']),
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.mainTabSelected = 'tokens')),
                "data-bs-target": "#pills-game-token"
              }, _hoisted_48, 2)
            ]),
            _createElementVNode("li", _hoisted_49, [
              _createElementVNode("button", {
                class: _normalizeClass(["text-gray-text p-3 hover:text-white", _ctx.mainTabSelected=='releases'?'active':'inActive']),
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.mainTabSelected = 'releases')),
                "data-bs-target": "#pills-game-release"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-list",
                  class: "inline-block mr-2"
                }),
                _hoisted_50
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            (_ctx.mainTabSelected == 'games')
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createElementVNode("nav", null, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["text-gray-text", _ctx.gameTabSelected == 'details'?'active':'']),
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.gameTabSelected = 'details'))
                      }, "Details", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["text-gray-text", _ctx.gameTabSelected == 'about'?'active':'']),
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.gameTabSelected = 'about'))
                      }, "About", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["text-gray-text", _ctx.gameTabSelected == 'gallery'?'active':'']),
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.gameTabSelected = 'gallery'))
                      }, "Gallery", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    (_ctx.gameTabSelected == 'details')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("div", _hoisted_56, [
                            (_ctx.gameData)
                              ? (_openBlock(), _createBlock(_component_game_details, {
                                  key: 0,
                                  gameData: _ctx.gameData,
                                  getGameDetails: _ctx.getGameDetails,
                                  imageFiles: _ctx.imageFiles,
                                  ref: "gameDetails"
                                }, null, 8, ["gameData", "getGameDetails", "imageFiles"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.gameTabSelected == 'about')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            (_ctx.gameData)
                              ? (_openBlock(), _createBlock(_component_about, {
                                  key: 0,
                                  gameData: _ctx.gameData
                                }, null, 8, ["gameData"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.gameTabSelected == 'gallery')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_gallery)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.mainTabSelected == 'tokens')
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createVNode(_component_gameToken)
                ]))
              : _createCommentVNode("", true),
            (_ctx.mainTabSelected == 'releases')
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _createVNode(_component_gameRelease, {
                    onLoader: _ctx.getLoaderStatus,
                    onUploads: _ctx.showProgressBar
                  }, null, 8, ["onLoader", "onUploads"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("div", _hoisted_67, [
                _hoisted_68,
                _createElementVNode("p", _hoisted_69, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-clock",
                    class: "online-block mr-2"
                  }),
                  _hoisted_70,
                  _hoisted_71,
                  _createTextVNode(_toDisplayString(_ctx.createdTime) + " " + _toDisplayString(_ctx.createdDate), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: {name: 'viewGamesPreview', params: {gameId: _ctx.gameId}},
                  class: "m-0 text-gray-text hover:text-white hover:underline transition-all duration-200"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-eye",
                      class: "inline-block mr-2"
                    }),
                    _hoisted_72
                  ]),
                  _: 1
                }, 8, ["to"]),
                (_ctx.webglRelease.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _createVNode(_component_router_link, {
                        to: { name: 'viewGamesPlay', params: { gameId: _ctx.gameId }},
                        class: "text-gray-text my-4 block hover:text-white hover:underline transition-all duration-200"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-display",
                            class: "inline-block mr-2"
                          }),
                          _hoisted_74
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.androidRelease.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _createElementVNode("a", {
                        href: `${_ctx.assetUrl}blob/releases/Android/${_ctx.gameId}/${_ctx.androidRelease[0].package}.apk`,
                        target: "_new",
                        class: "hover:text-white hover:underline transition-all duration-200"
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-brands fa-android",
                          class: "inline-block mr-2"
                        }),
                        _createTextVNode("Android game apk (" + _toDisplayString(_ctx.androidRelease[0].version) + ")", 1)
                      ], 8, _hoisted_76)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_77, [
              (_ctx.status != 2 && (_ctx.webglRelease.length > 0 || _ctx.androidRelease.length > 0))
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _hoisted_79,
                    (_ctx.webglRelease.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, "Release" + _toDisplayString(_ctx.webglRelease.length>1?'s':'') + " in WebGL", 1),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.selectedWebglRelease) = $event)),
                              class: "p-2 bg-gray-300 cursor-pointer rounded-md focus:border-0"
                            }, [
                              _hoisted_82,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.webglRelease, (release, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: index,
                                  value: release.version
                                }, _toDisplayString(release.version), 9, _hoisted_83))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.selectedWebglRelease]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.androidRelease.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, "Release" + _toDisplayString(_ctx.androidRelease.length>1?'s':'') + " in Android", 1),
                          _createElementVNode("div", null, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.selectedAndroidRelease) = $event)),
                              class: "p-2 bg-gray-300 cursor-pointer rounded-md focus:border-0"
                            }, [
                              _hoisted_86,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.androidRelease, (release, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: index,
                                  value: release.version
                                }, _toDisplayString(release.version), 9, _hoisted_87))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, _ctx.selectedAndroidRelease]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.status != 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "py-3 text-sm btn-primary md:w-full",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.submitGameForReview && _ctx.submitGameForReview(...args))),
                    disabled: _ctx.selectedWebglRelease == '' && _ctx.selectedAndroidRelease == '' && !_ctx.enableSubmitButton
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-save",
                      class: "text-white mr-2 inline-block"
                    }),
                    _createTextVNode("Submit in " + _toDisplayString(_ctx.testnetLabel), 1)
                  ], 8, _hoisted_88))
                : _createCommentVNode("", true),
              (_ctx.status === 2)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn-primary md:w-full",
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.publishGame && _ctx.publishGame(...args))),
                    disabled: !_ctx.enableSubmitButton
                  }, [
                    _hoisted_90,
                    _createTextVNode(" Release in " + _toDisplayString(_ctx.testnetLabel), 1)
                  ], 8, _hoisted_89))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "text-gray-text mt-3 text-xs relative cursor-pointer hover:underline",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isDisplaySubmitCheckList = !_ctx.isDisplaySubmitCheckList))
              }, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" }),
                _hoisted_91,
                (_ctx.isDisplaySubmitCheckList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      _hoisted_93,
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-check",
                            class: _normalizeClass(this.gameData.game.tags.length > 0 && this.gameData.game.languages.length > 0 ? 'text-success-check': 'text-gray-text')
                          }, null, 8, ["class"])
                        ]),
                        _hoisted_95
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-check",
                            class: _normalizeClass(this.gameData.details.about != undefined ? 'text-success-check': 'text-gray-text')
                          }, null, 8, ["class"])
                        ]),
                        _hoisted_97
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-check",
                            class: _normalizeClass(this.previewCoverImage != '' ? 'text-success-check': 'text-gray-text')
                          }, null, 8, ["class"])
                        ]),
                        _hoisted_99
                      ]),
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-check",
                            class: _normalizeClass(this.previewImage != '' ? 'text-success-check': 'text-gray-text')
                          }, null, 8, ["class"])
                        ]),
                        _hoisted_101
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-check",
                            class: _normalizeClass(this.gallery.length > 0 ? 'text-success-check': 'text-gray-text')
                          }, null, 8, ["class"])
                        ]),
                        _hoisted_103
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_104,
          _createElementVNode("div", _hoisted_105, [
            _createElementVNode("div", _hoisted_106, [
              _hoisted_107,
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.testnetLabel) + " Environment", 1),
                (_ctx.status === 3)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_110, "Game is currently active in " + _toDisplayString(_ctx.testnetLabel), 1))
                  : _createCommentVNode("", true),
                (_ctx.status === 2)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_111, "Game approved"))
                  : _createCommentVNode("", true),
                (_ctx.status === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_112, "Game is awaiting for approval"))
                  : _createCommentVNode("", true),
                (_ctx.status === 4)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_113, "Game is awaiting submission"))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_114, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-clock",
                    class: "inline-block mr-2"
                  }),
                  _hoisted_115,
                  _hoisted_116,
                  _createTextVNode(_toDisplayString(_ctx.submitTime) + " " + _toDisplayString(_ctx.submitDate), 1)
                ]),
                (_ctx.status === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                      (_ctx.webglRelease.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                            _createVNode(_component_router_link, {
                              to: { name: 'viewGamesPlay', params: { gameId: _ctx.gameId }},
                              class: "text-gray-text my-4 block hover:text-white hover:underline transition-all duration-200"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "fa-solid fa-display",
                                  class: "inline-block mr-2"
                                }),
                                _hoisted_119
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.androidRelease.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                            _createElementVNode("a", {
                              href: `${_ctx.assetUrl}blob/releases/Android/${_ctx.gameId}/${_ctx.androidRelease[0].package}.apk`,
                              target: "_new",
                              class: "hover:text-white hover:underline transition-all duration-200"
                            }, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "fa-brands fa-android",
                                class: "inline-block mr-2"
                              }),
                              _createTextVNode("Android game apk (" + _toDisplayString(_ctx.androidRelease[0].version) + ")", 1)
                            ], 8, _hoisted_121)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_122
            ])
          ]),
          _hoisted_123,
          (_ctx.userData.mainnetWalletAddress)
            ? (_openBlock(), _createBlock(_component_gamesUpdateSubmitMainnetGameComponent, {
                key: 0,
                status: _ctx.status,
                onHideLoader: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showLoader = false)),
                onShowLoader: _cache[25] || (_cache[25] = ($event: any) => {_ctx.showLoader = true; _ctx.releaseTestNet = true})
              }, null, 8, ["status"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayInviteGamersModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_124))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayInviteGamersModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("div", _hoisted_128, [
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("div", _hoisted_130, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.isDisplayInviteGamersModal = false))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        _hoisted_131,
                        _createElementVNode("nav", _hoisted_132, [
                          _createElementVNode("div", _hoisted_133, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["text-gray-text active py-2 px-4", _ctx.currentInviteTab=='testnet'?'bg-black-header':'cursor-pointer']),
                              id: "nav-details-tab",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.currentInviteTab = 'testnet'))
                            }, [
                              _createElementVNode("div", _hoisted_134, [
                                _hoisted_135,
                                _createElementVNode("span", null, _toDisplayString(_ctx.testnetLabel), 1)
                              ])
                            ], 2),
                            (_ctx.userData.mainnetWalletAddress)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["text-gray-text active py-2 px-4 ml-2", _ctx.currentInviteTab=='mainnet'?'bg-black-header':'cursor-pointer']),
                                  id: "nav-details-tab",
                                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.currentInviteTab = 'mainnet'))
                                }, [
                                  _createElementVNode("div", _hoisted_136, [
                                    _hoisted_137,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.mainnetLabel), 1)
                                  ])
                                ], 2))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.currentInviteTab == 'testnet')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                              _createElementVNode("p", _hoisted_139, "Invite users via an invitation email which has a link to your " + _toDisplayString(_ctx.testnetLabel) + " Game Page to play/test " + _toDisplayString(_ctx.gameName) + " " + _toDisplayString(_ctx.testnetLabel) + " game.", 1),
                              _createElementVNode("div", _hoisted_140, [
                                _hoisted_141,
                                _createElementVNode("div", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedGamers, (addedGamer, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "rounded-md bg-green-800 text-sm text-gray-200 px-2 py-1 inline-block mb-2 mr-2",
                                      key: index
                                    }, _toDisplayString(addedGamer), 1))
                                  }), 128)),
                                  (_ctx.addedGamers.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_142, "None"))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_143, [
                                _hoisted_144,
                                _createElementVNode("div", _hoisted_145, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "text-white border-0 flex-grow mr-1 rounded-md outline-none bg-black-primary p-2",
                                    rows: "5",
                                    id: "email",
                                    placeholder: "Enter emails to invite",
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.gamerEmail) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.gamerEmail]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn-primary w-14 items-center justify-center flex",
                                    onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.addGamer && _ctx.addGamer(...args)))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "fa-solid fa-envelope",
                                      class: "inline-block mr-2"
                                    }),
                                    _hoisted_146
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_147, [
                                _hoisted_148,
                                _createElementVNode("div", _hoisted_149, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invitedGamers, (gamer, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "inline-block rounded-sm bg-black-sidebar p-1 mb-1 mr-1 items-center",
                                      key: index
                                    }, [
                                      _createTextVNode(_toDisplayString(gamer) + " ", 1),
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "fa-solid fa-close",
                                        class: "ml-1 text-gray-300 hover:text-white inline-block cursor-pointer",
                                        onClick: ($event: any) => (_ctx.removeGamer(index))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_150, [
                              _createElementVNode("p", _hoisted_151, "Invite users via an invitation email which has a link to your " + _toDisplayString(_ctx.mainnetLabel) + " Game Page to play " + _toDisplayString(_ctx.gameName) + " " + _toDisplayString(_ctx.mainnetLabel) + " game.", 1),
                              _createElementVNode("div", _hoisted_152, [
                                _hoisted_153,
                                _createElementVNode("div", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedMainnetGamers, (addedGamer, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "rounded-md bg-green-800 text-sm text-gray-200 px-2 py-1 inline-block mb-2 mr-2",
                                      key: index
                                    }, _toDisplayString(addedGamer), 1))
                                  }), 128)),
                                  (_ctx.addedMainnetGamers.length == 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_154, "None"))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_155, [
                                _hoisted_156,
                                _createElementVNode("div", _hoisted_157, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    class: "text-white border-0 flex-grow mr-1 rounded-md outline-none bg-black-primary p-2",
                                    rows: "5",
                                    id: "email",
                                    placeholder: "Enter emails to invite",
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.gamerEmail) = $event))
                                  }, null, 512), [
                                    [_vModelText, _ctx.gamerEmail]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn-primary w-14 items-center justify-center flex",
                                    onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.addGamer && _ctx.addGamer(...args)))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "fa-solid fa-envelope",
                                      class: "inline-block mr-2"
                                    }),
                                    _hoisted_158
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_159, [
                                _hoisted_160,
                                _createElementVNode("div", _hoisted_161, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invitedGamers, (gamer, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "inline-block rounded-sm bg-black-sidebar p-1 mb-1 mr-1 items-center",
                                      key: index
                                    }, [
                                      _createTextVNode(_toDisplayString(gamer) + " ", 1),
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "fa-solid fa-close",
                                        class: "ml-1 text-gray-300 hover:text-white inline-block cursor-pointer",
                                        onClick: ($event: any) => (_ctx.removeGamer(index))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])),
                        _createElementVNode("div", _hoisted_162, [
                          _createElementVNode("button", {
                            class: "btn text-gray-text hover:text-gray-200 duration-200 transition-all mt-3",
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.isDisplayInviteGamersModal = false))
                          }, "Cancel"),
                          _createElementVNode("button", {
                            class: "btn btn-primary mt-3 float-end",
                            onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.inviteGamers(_ctx.currentInviteTab))),
                            disabled: _ctx.isInvitingGamers
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "fa-solid fa-envelope",
                              class: "inline-block mr-2"
                            }),
                            _createTextVNode(_toDisplayString(_ctx.isInvitingGamers?'Sending...':'Send Invite'), 1)
                          ], 8, _hoisted_163)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayUpdateGameModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_164))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayUpdateGameModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("div", _hoisted_167, [
                  _createElementVNode("div", _hoisted_168, [
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("div", _hoisted_170, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.isDisplayUpdateGameModal = false))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        _hoisted_171,
                        _createElementVNode("div", _hoisted_172, [
                          _hoisted_173,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "rounded-sm p-2 w-full bg-black-primary text-white border-0 outline-none",
                            placeholder: "Enter Game Name",
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.gameTitle) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.gameTitle]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_174, [
                          _createElementVNode("button", {
                            class: "btn text-gray-text hover:text-gray-200 duration-200 transition-all mt-3",
                            onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.isDisplayUpdateGameModal = false))
                          }, "Cancel"),
                          _createElementVNode("button", {
                            class: "btn btn-primary mt-3 float-end",
                            onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.updateGameTitle && _ctx.updateGameTitle(...args)))
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "fa-solid fa-save",
                              class: "inline-block"
                            }),
                            _hoisted_175
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayRejectModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_176))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-100",
      "enter-from-class": "transform opacity-0 scale-95",
      "enter-to-class": "transform opacity-100 scale-100",
      "leave-active-class": "transition ease-in duration-75",
      "leave-from-class": "transform opacity-100 scale-100",
      "leave-to-class": "transform opacity-0 scale-95"
    }, {
      default: _withCtx(() => [
        (_ctx.isDisplayRejectModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
              _createElementVNode("div", _hoisted_178, [
                _createElementVNode("div", _hoisted_179, [
                  _createElementVNode("div", _hoisted_180, [
                    _createElementVNode("div", _hoisted_181, [
                      _createElementVNode("div", _hoisted_182, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "absolute right-2 top-2 hover:bg-gray-700 w-8 h-8 items-center rounded-md text-sm",
                          onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.isDisplayRejectModal = false))
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "fa-solid fa-close",
                            class: "text-gray-text p-0 text-end inline-block text-sm"
                          })
                        ]),
                        _hoisted_183,
                        _createElementVNode("div", _hoisted_184, [
                          _createElementVNode("table", _hoisted_185, [
                            _hoisted_186,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_187, [
                                _createElementVNode("td", _hoisted_188, _toDisplayString(_ctx.rejectedVersion), 1),
                                _createElementVNode("td", _hoisted_189, _toDisplayString(_ctx.rejectedText), 1)
                              ])
                            ])
                          ]),
                          _hoisted_190
                        ]),
                        _createElementVNode("div", _hoisted_191, [
                          _createElementVNode("button", {
                            class: "btn-secondary mt-3",
                            onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.isDisplayRejectModal = false))
                          }, "Close")
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}